import {
    JOB_ADS_FETCH,
    JOB_ADS_DETAILS_CLEAR,
    JOB_ADS_DETAILS_FETCH,
    JOB_ADS_ADD_TO_FAVOURITE,
    JOB_ADS_REMOVE_FROM_FAVOURITE,
    JOB_ADS_REPORT,
    DASHBOARD_JOB_REMOVE
} from './constants';
import {
    getJobsList,
    getJobDetails,
    addJobToFavourites,
    removeJobFromFavourites,
    reportJobAd,
    createJobAd,
    deleteJob
} from '../services/job'

export const startFetchJobAds = () => {
    return (dispatch, getState) => {
        const jobFilters = getState().jobFilters;
        return getJobsList({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            parameter: Object.keys(jobFilters).filter(key => !!jobFilters[key]).reduce((acc, cur) => ({
                ...acc,
                [cur]: jobFilters[cur]
            }), {})
        })
        .then((response) => {
            dispatch(fetchJobAds(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchJobAds = (payload) => ({
    type: JOB_ADS_FETCH,
    payload
});

export const clearJobDetails = () => ({
    type: JOB_ADS_DETAILS_CLEAR,
    payload: {}
})

export const startFetchJobDetails = (advertiseId) => {
    return (dispatch, getState) => {
        return getJobDetails(advertiseId)
        .then((response) => {
            dispatch(fetchJobDetails(response.data))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const fetchJobDetails = (payload) => ({
    type: JOB_ADS_DETAILS_FETCH,
    payload
});

export const startAddJobToFavourites = (id=0) => {
    return (dispatch, getState) => {
        return addJobToFavourites({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body: {
                jobAd: id
            }
        })
        .then((response) => {
            dispatch(markJob({id:[id]}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const markJob = (payload) => ({
    type: JOB_ADS_ADD_TO_FAVOURITE,
    payload
});

export const startRemoveJobFromFavourites = (id=0) => {
    return (dispatch, getState) => {
        return removeJobFromFavourites({
            header: {
                Authorization: `Token ${getState().auth.token}`
            }
        }, id)
        .then((response) => {
            dispatch(unMarkJob({id:[id]}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const unMarkJob = (payload) => ({
    type: JOB_ADS_REMOVE_FROM_FAVOURITE,
    payload
});

export const startReportJobAd = (id=0) => {
    return (dispatch, getState) => {
        return reportJobAd({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body: {
                targetJobAd: id
            }
        })
        .then((response) => {
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startCreateJobAd = (body) => {
    return (dispatch, getState) => {
        return createJobAd({
            header: {
                Authorization: `Token ${getState().auth.token}`
            },
            body
        })
        .then((response) => {
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

export const startDeleteJob = (id=0) => {
    return (dispatch, getState) => {
        return deleteJob({
            header: {
                Authorization: `Token ${getState().auth.token}`
            }
        }, id)
        .then((response) => {
            dispatch(deleteJobAction({id}))
            return {
                success: {
                    status: response.status,
                    body: response.data
                }
            }
        })
        .catch((error) => {
            return {
                error: {
                    status: error.response.status,
                    body: error.response.data
                }
            }
        })
    }
};

const deleteJobAction = (payload) => ({
    type: DASHBOARD_JOB_REMOVE,
    payload
});